import { Order } from '../apiTypes';

export const canClose = (order: Order, skipPrro: boolean = false) =>
  Object.values(order.items).every((i) => i.status === 'complete') &&
  order.paid !== null &&
  (!order.status || order.status === 'complete' || order.type === 'regular') &&
  (!order.prroReceipts || skipPrro || Object.values(order.prroReceipts).every((r) => r.status === 'complete'));
